export default [
  { label: '500-1k', value: 0.5 },
  { label: '1k-10k', value: 1 },
  { label: '10k-50k', value: 10 },
  { label: '50k-100k', value: 50 },
  { label: '100k-500k', value: 100 },
  { label: '>500k', value: 500 }
];
